const roles = {
  admin: 'Admin',
  investigator: 'Investigator',
  customerSupervisor: 'CustomerSupervisor',
  candidate: 'Candidate',
  customer: 'Customer',
};

export default roles;
